import { ClubsScheduleView } from "../schedule/ClubsScheduleView";
import { clubsSchedule } from "../schedule/data";

export const Raspisanie = () => <ClubsScheduleView schedule={clubsSchedule} />;
